import React from "react";
import { Box, Typography, Container, Button } from "@mui/material";
import HeroSection from "./HeroSection";
import ValuePropsStrip from "./ValuePropsStrip";
import GalleryStrip from "./GalleryStrip";
import { useNavigate } from "react-router-dom";

const DecoratingLandingPage = () => {
  const navigate = useNavigate();

  const handleBookNow = () => {
    navigate("/classes/decorating/book");
  };

  return (
    <Box>
      <HeroSection onBookNow={handleBookNow} />

      <Container sx={{ py: 6 }}>
        <ValuePropsStrip />
      </Container>

      <Container sx={{ py: 6 }}>
        <GalleryStrip />
      </Container>

      <Box sx={{ py: 6, textAlign: "center" }}>
        <Typography variant="h5" gutterBottom>
          Ready to have fun and decorate your own cake?
        </Typography>
        <Button variant="contained" color="primary" onClick={handleBookNow}>
          Book Your Spot Now
        </Button>
      </Box>
    </Box>
  );
};

export default DecoratingLandingPage;
